import { render, staticRenderFns } from "./OrganizationManagement.vue?vue&type=template&id=408d0223&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&id=408d0223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d0223",
  null
  
)

export default component.exports